<app-collapsible-container
    [id]="'school'"
    [title]="'REPERTOIRE.FORMS.SCHOOLS.TITLE'"
    [icon]="'i-school'"
    [maxSelection]="maxSchoolSelection"
    [currentSelected]="control.value.length"
    (elementSizeModification)="elementSizeModification.emit()"
>
    <app-generic-radio-checkbox [config]="radioConfig" [formControl]="control" [readOnly]="readonly"></app-generic-radio-checkbox>
    <app-form-errors *ngIf="control.touched" [errors]="control.errors" (errorDisplay)="elementSizeModification.emit()"></app-form-errors>
</app-collapsible-container>
